// 首页
const HomePage = () => import('@/pages/homePage/homePage.vue')
// 通知公告
const PublicAnnouncement = () => import('@/pages/publicAnnouncement/publicAnnouncement.vue')
const SubjectArea = () => import('@/pages/subjectArea/index.vue')
const AnswerQuestions = () => import('@/pages/answerQuestions/answerQuestions.vue')
// 标准与指南
const DownloadCenter = () => import('@/pages/downloadCenter/downloadCenter.vue')
// 详情页面
const smartDrain = () => import('@/pages/smartDrain/smartDrain.vue')
const smartDrains_copy = () => import('@/pages/smartDrains/_index.vue')
const caseShare = () => import('@/pages/caseShare/caseShare.vue')
const participation = () => import('@/pages/participating/index.vue')
const registration = () => import('@/pages/participating/regist.vue')

export default [
    {
        path: "/",
        // redirect重定向
        redirect: "/home_page"
    },
    {
        path: '/home_page',
        component: HomePage
    }, {
        path: '/public_announcement',
        component: PublicAnnouncement,
    }, {
        path: '/subject_area',
        component: SubjectArea,
    }, {
        path: '/answer_questions',
        component: AnswerQuestions
    }, {
        path: '/download_center',
        component: DownloadCenter
    },
    {
        path: '/smart_drain',
        component: smartDrain
    },
    {
        path: '/smart_drainsView',
        component: smartDrains_copy
    },
    {
        path: '/case_share',
        component: caseShare
    },
    {
        // path: '/participating',
        path: '/pxbm',
        component: participation,
        meta: {
            layout: 'hidden'
        }
    },
    {
        path: '/registration',
        component: registration,
        meta: {
            layout: 'hidden'
        }
    },
]
